import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { documentService } from 'domain/documents/api/documentService';
import { indexedItemKey } from 'domain/documents/schemas/document';

export const favoriteDocumentsQueryKey = 'favoriteDocuments';

const NO_FAVORITES: never[] = [];

export default function useGetFavoriteDocuments() {
  const { data, isLoading } = useQuery({
    queryKey: [favoriteDocumentsQueryKey],
    queryFn: documentService.getFavorites,
  });

  const favorites = data ?? NO_FAVORITES;

  // Les résultats de recherche ne portent pas d'indicateur de favori : c'est le croisement avec
  // cette liste qui le donne. Un ensemble rend le test d'appartenance immédiat, et l'invalidation
  // de cette seule requête suffit à rafraîchir tous les cœurs affichés. La clé porte la source :
  // deux sources peuvent attribuer le même identifiant.
  const favoriteKeys = useMemo(() => new Set(favorites.map(indexedItemKey)), [favorites]);

  return { favorites, favoriteKeys, isLoading };
}
